import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const downloadInsightReport = {
  name: "downloadInsightReport" as const,
  input: z.object({ reportId: zExt.objectId() }),
  output: z.object({ downloadUrl: z.string() }),
};
